
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  DebugParam.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\DebugParam.ts

export class DebugParam {

  // int Id
  public Id: number=0;

  // string UserId
  public UserId?: string=null;

  // byte? DebugActif
  public DebugActif?: number=null;

  // int? ProfilId
  public ProfilId?: number=null;
}